// Phase 1 — the pre-flight pop. The fly's source is now the claim-celebration TILE, which has
// already had its center-stage moment beside the coins, so this is a takeoff cue, not the hero
// beat it was when the pack popped out of the closing dialog (the old 3x, tuned round 6, read as
// oversized from the tile — 2026-07-21 QA). 1.6x matches mobile's fly pop. Settles at
// PACK_FLY_POP_SCALE and stays there until the fly leg launches and takes over the scale
// animation from wherever it currently is.
export const PACK_FLY_SCALE_POP_S = 0.28;
export const PACK_FLY_POP_SCALE = 1.6;
export const PACK_FLY_HERO_DRIFT_PX = 24;

// Phase 2 — the fly leg: only launched once the claim dialog is confirmed gone (via
// RipsPackClaimFlyHost watching uiStore.openDialog), so the takeoff reads against the lobby, not
// the modal. Lands BY SHRINKING INTO the widget — position+scale run for the full duration so the
// player can track it all the way in; opacity is held near-1 and only fades in the final stretch
// (see PACK_FLY_FADE_MS) so the fade can never finish ahead of the movement.
export const PACK_FLY_TRAVEL_S = 0.62;
export const PACK_FLY_END_SCALE = 0.2;
export const PACK_FLY_FADE_MS = 100;

export const PACK_FLY_FALLBACK_TARGET_MARGIN_PX = 48;

// Safety cap only: if the "dialog closed" signal never arrives (store bug, dropped update, etc.),
// launch the fly leg anyway after this long so the clone can never hold forever. ~1.5s per QA.
export const PACK_FLY_HOLD_CAP_MS = 1500;

// Safety net only (mirrors PACK_FLY_HOLD_CAP_MS above, for the fly phase instead of the hold phase):
// onAnimationComplete already resolves as soon as the fly leg finishes — this guarantees the flight
// can never hang even if the animation fails to fire that callback (e.g. the tab is backgrounded and
// rAF is throttled). Exported (not local to useRipsPackClaimFly) so PACK_FLY_ADVANCE_CAP_MS below can
// derive from it.
export const FLY_SAFETY_TIMEOUT_MS = PACK_FLY_TRAVEL_S * 1000 + 500;

// Hard cap (round 6) on how long the claim dialog's popup-advance sequence (showNextPopup / the
// next queued bingo/daily-bonus/etc. dialog) will wait for this flight before proceeding anyway —
// see EventTriggerStore.awaitRipsPackClaimFlyDone. A missed advance wedges every future popup, so
// this must fire unconditionally regardless of why the flight didn't finish in time. Derived (not
// independently declared): the popup queue must outwait the flight's own worst case.
export const PACK_FLY_ADVANCE_CAP_MS = PACK_FLY_HOLD_CAP_MS + FLY_SAFETY_TIMEOUT_MS + 200;
